import { type PropsWithChildren } from "react";

export function WallPreviewContainer({ children }: PropsWithChildren) {
  return (
    <div className="flex flex-col items-center justify-center max-h-96 w-full min-w-0">
      <div className="grow min-w-0 min-h-0 max-w-full max-h-full">
        {children}
      </div>
    </div>
  );
}
